import { gql } from '@common/hooks';
import { OrganizationBusinessType } from '@institutions/types';

export const updateOrganizationBusinessMutation = gql`
  mutation UpdateOrganizationBusinessMutation(
    $id: ID!
    $input: UpdateOrganizationBusinessInput!
  ) {
    updateOrganizationBusiness(id: $id, input: $input) {
      organizationBusiness {
        id
        name
        address
        postalCode
        city
        country
        stateCode
        timeZone
      }
    }
  }
`;

export type UpdateOrganizationBusinessMutationVariables = {
  id: string;
  input: {
    name: string;
    address: string;
    postalCode: string;
    city: string;
    country: string;
    stateCode: string;
    timeZone: string;
  };
};

export type UpdateOrganizationBusinessMutationResponse = {
  updateOrganizationBusiness: {
    organizationBusiness: OrganizationBusinessType;
  };
};
